var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.2929 8.22222C23.9135 4.47027 19.8616 2 15.2632 2C7.93812 2 2 8.26802 2 16C2 23.732 7.93812 30 15.2632 30C19.1913 30 22.7206 28.1974 25.1491 25.3333M21.1579 16.4444L23.8105 19.1111L30 12.8889M15.2632 9.77778V17.5556M15.2632 22.2222H15.2779",
    stroke: "#A2C4CD",
    strokeWidth: 2.69,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/successTick.b90b1b7357cc82a8f5728c3f430fba41.svg";
export { ForwardRef as ReactComponent };